import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { DateTime } from 'luxon'

class AddEntry extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      form: {
        date: DateTime.local().toFormat('yyyy-MM-dd'),
        text: ''
      }
    };
    this.toggle = this.toggle.bind(this);
    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  onChange(e) {
    switch (e.target.id) {
      case 'date':
        this.setState({ form: { ...this.state.form, date: e.target.value } })
        break;
      case 'text':
        this.setState({ form: { ...this.state.form, text: e.target.value } })
        break;
      default:
        break;
    }
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  save() {
    this.props.save(this.state.form)
    this.setState({
      modal: false,
      form: {
        date: DateTime.local().toFormat('yyyy-MM-dd'),
        text: ''
      }
    });
    this.toggle()
  }

  render() {
    return (
      <div className="container-fluid">
        <div>
          <Button color="success" className="addbutton" onClick={this.toggle}>
            <i className="fas fa-plus" />
          </Button>
          <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
            <ModalHeader toggle={this.toggle}>New Entry</ModalHeader>
            <ModalBody>
              <Form onSubmit={this.save}>
                <FormGroup>
                  <Label for="date">Date</Label>
                  <Input type="date" name="date" id="date" defaultValue={this.state.form.date} onChange={this.onChange} />
                </FormGroup>
                <FormGroup>
                  <Label for="text">Text</Label>
                  <Input type="textarea" name="text" id="text" rows="10" placeholder="How are you doing?" defaultValue={this.state.form.text} onChange={this.onChange} />
                </FormGroup>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit" onClick={this.save}>Save</Button>{' '}
              <Button color="secondary" onClick={this.toggle}>Cancel</Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default AddEntry